import { gql } from '@apollo/client';

const organization_fields = `
	OrganizationId
	Name
	Logo
`;

const userInGroup_fields = `
	UserInGroupId
	User {
		UserId
		Firstname
		Lastname
		Email
		Phone
		Abbr
		UserState
		OwnOrganization {
			${organization_fields}
		}
	}
	UserGroup {
		UserGroupId
	}
	Created
	LastUpdate
`;

const userGroupType_fields = `
	UserGroupTypeId
	Name
	MembersMin
	MembersMax
	Created
	Updated
`;

const pricingPlan_fields = `
	PlanId
	Name
	IsActive
	Organization {
		${organization_fields}
	}
	OptionIncluded {
		OptionIncludedId
	}
	Subscription {
		SubscriptionId
	}
`;

const subscription_fields = `
	SubscriptionId
	Plan {
		PlanId
		Name
		IsActive
	}
	Created
	Updated
`;

const userGroup_fields = `
	UserGroupId
	Name
	CustomerInvoiceText
	Organization {
		${organization_fields}
	}
	UserInGroup {
		${userInGroup_fields}
	}
	UserGroupType {
		${userGroupType_fields}
	}
	Subscription {
		${subscription_fields}
	}
	Plans {
		${pricingPlan_fields}
	}
	Created
	Updated
`;

export const GET_USER_GROUPS = gql`
query UserGroup {
	userGroups {
		${userGroup_fields}
	}
}
`;

export const CREATE_USER_GROUP = gql`
mutation createUserGroup(
	$Name: String!,
	$UserGroupTypeId: Int!,
	$CustomerInvoiceText: String!,
	$OrganizationId: Int,
	$UserIds: [Int!],
	$PlanIds: [Int!]
) {
  createUserGroup(
		data:{
			Name: $Name,
			UserGroupTypeId: $UserGroupTypeId,
			CustomerInvoiceText: $CustomerInvoiceText,
			OrganizationId: $OrganizationId,
			UserIds: $UserIds,
			PlanIds: $PlanIds
		}
	) {
		${userGroup_fields}
	}
}
`;

export const UPDATE_USER_GROUP = gql`
mutation updateUserGroup(
	$UserGroupId: Int!,
	$Name: String,
	$UserGroupTypeId: Int,
	$CustomerInvoiceText: String,
	$OrganizationId: Int,
	$UserIds: [Int!],
	$PlanIds: [Int!]
) {
  updateUserGroup(
		data:{
			UserGroupId: $UserGroupId,
			Name: $Name,
			UserGroupTypeId: $UserGroupTypeId,
			CustomerInvoiceText: $CustomerInvoiceText,
			OrganizationId: $OrganizationId,
			UserIds: $UserIds,
			PlanIds: $PlanIds
		}
	) {
		${userGroup_fields}
	}
}
`;

export const DELETE_USER_GROUP = gql`
    mutation deleteUserGroup($UserGroupId: Int!) {
        deleteUserGroup(data: { UserGroupId: $UserGroupId })
    }
`;
